var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from "@angular/material/dialog";
import { BaseComponent } from "../../../../../../common/components/base.component";
import { HubApiService } from 'services/hub.api.service';
import { ImageService } from "../../../../../../services/image.service";
import { SearchGooglePlaceResultModalActions, SearchGooglePlaceResultModalData } from './search.google.place.result.modal.provider';
import { AlertifyService } from "../../../../../../services/alertify.service";
import { ShowInfoModalComponent } from "../../../../show.info.modal/show.info.modal.component";
import { InfoModalData, ShowInfoModalActions } from "../../../../show.info.modal/show.info.modal.provider";
import { ModalService } from "../../../../../../common/services/modal.service";
import { ImageSelectorCommand } from 'common/components/image.selector/image.selector.component';
import { EditPlaceCategoryModalActions } from '../../../../edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../../../edit.place.category.modal/edit.place.category.modal.component';
import { HubPlace } from '../../../../../../models/hub/hub.place';
import { CustomDefaultPlaceCategoryStore } from '../../../../../../stores/hub.calendar.store';
import { clone, isEmptyObject } from '../../../../../../common/extensions';
var SearchGooglePlaceResultModalComponent = /** @class */ (function (_super) {
    __extends(SearchGooglePlaceResultModalComponent, _super);
    function SearchGooglePlaceResultModalComponent(dialogRef, actions, hubApiService, imageService, alertify, modalService, formBuilder, customDefaultPlaceCategoryStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.formBuilder = formBuilder;
        _this.customDefaultPlaceCategoryStore = customDefaultPlaceCategoryStore;
        _this.command = new ImageSelectorCommand();
        _this.selectedImageData = null;
        _this.isApproved = true;
        _this.isUseDefaultCustomPlaceCategory = true;
        _this.data = Object.assign({}, data);
        // set the first place checkbox checked
        if (_this.data.places && _this.data.places.length > 0 && !_this.data.places[0].existed) {
            _this.data.places[0].checked = true;
        }
        _this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(_this.isDestroyed).subscribe(function (category) {
            if (!isEmptyObject(category)) {
                _this.isUseDefaultCustomPlaceCategory = category.useDefault;
            }
        });
        return _this;
    }
    SearchGooglePlaceResultModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    SearchGooglePlaceResultModalComponent.prototype.notAllowed = function (place) {
        return !this.data.allowedCategories.any(function (x) { return place.types.any(function (y) { return x === y; }); });
    };
    SearchGooglePlaceResultModalComponent.prototype.isAllPlaceCategoriesNotMatched = function () {
        var _this = this;
        var result = this.data.places
            .filter(function (x) { return x.checked; })
            .any(function (place) { return _this.data.allowedCategories.any(function (category) { return place.types.any(function (type) { return category === type; }); }); });
        return !result;
    };
    SearchGooglePlaceResultModalComponent.prototype.showEditCategoryModal = function (place) {
        var actions = {
            confirm: function (event, category) {
                place.types = category.categoryList;
            },
        };
        var placeCategories = clone(place.types);
        this.modalService.show({
            component: EditPlaceCategoryModalComponent,
            providers: [
                { provide: EditPlaceCategoryModalActions, useValue: actions },
                {
                    provide: HubPlace,
                    useValue: {
                        hubName: this.data.hubName,
                        categoryText: placeCategories.join(', '),
                        categoryList: placeCategories || [],
                    },
                },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    SearchGooglePlaceResultModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.data.places.any(function (x) { return x.checked; })) {
                    this.alertify.warning('Please select at least one place you want to add');
                    event.complete();
                    return [2 /*return*/];
                }
                if (this.data.places.any(function (x) { return !x.types.length; })) {
                    this.alertify.warning('Please select at least one type for the places you want to add');
                    event.complete();
                    return [2 /*return*/];
                }
                this.hubApiService.saveGooglePlace(this.data.hubName, this.isApproved, this.data.places.filter(function (x) { return x.checked; }).first())
                    .finally(event.complete)
                    .subscribe(function (data) {
                    var icons = [], text = [];
                    if (data.saved) {
                        icons.push({ icon: 'check', color: 'green' });
                        text.push(data.saved + " place(s) saved successfully");
                    }
                    if (data.updated) {
                        icons.push({ icon: 'cached', color: 'green' });
                        text.push(data.updated + " place(s) updated");
                    }
                    _this.modalService.show({
                        component: ShowInfoModalComponent,
                        providers: [
                            { provide: ShowInfoModalActions, useValue: null },
                            {
                                provide: InfoModalData,
                                useValue: new InfoModalData('Result', icons, text)
                            }
                        ],
                        panelClass: 'width-modal-3'
                    });
                    _this.dialogRef.close();
                });
                return [2 /*return*/];
            });
        });
    };
    SearchGooglePlaceResultModalComponent.prototype.updateImage = function ($event, place) {
        place.uploadedImage = $event || null;
    };
    SearchGooglePlaceResultModalComponent.prototype.selectedChanged = function (place) {
        this.data.places.filter(function (x) { return x.place_id !== place.place_id; }).forEach(function (y) { return y.checked = false; });
    };
    SearchGooglePlaceResultModalComponent.prototype.isTypeBlocked = function (type) {
        return this.data.blockedCategories.indexOf(type) >= 0;
    };
    SearchGooglePlaceResultModalComponent.prototype.removeType = function (place, type) {
        place.types = place.types.filter(function (x) { return x !== type; });
        console.log(place.types);
    };
    return SearchGooglePlaceResultModalComponent;
}(BaseComponent));
export { SearchGooglePlaceResultModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.result.modal/search.google.place.result.modal.component.ts.pre-build-optimizer.js